export const waitForFormCompletionDocumentationMarkdown = `
# Wait for Form Completion

Following execution of a **Form** block, this block waits until the associated form reaches a terminal state or times out,
according to a configurable timeout duration

### Form Completion Events
 - **Completed**: The form was sent to a patient, received, filled out, and submitted.
 - **Expired**: The form was not completed before the time limit was reached.
 - **Terminal**: This event occurs when the form is either Completed or Expired.
    It indicates that the form process is finished, regardless of the outcome.
    Use this event when you want to continue the flow, regardless of the form's status.

### What this Block returns
When the block detects the form's status, it sends back information that includes:
 - \`formSetId\`: This is a unique ID for the Form Set, which you can use with the **Get Form Set** block to retrieve its details using *Type*="User Defined"
 - \`formSetStatus\`: This shows the form's status ("Completed" or "Expired"), primarily useful for the Terminal event to indicate status.

The payload:
\`\`\`
  {
    formSetId: '...',
    formSetStatus: '...',
  }
\`\`\`
`;
